export default __webpack_public_path__ + "static/media/1.9fd32de4.svg";